import { Controller } from "@hotwired/stimulus"

// Asks for confirmation (Turbo's confirm, i.e. the app's own modal) only when a box that was
// ticked on page load gets unticked — e.g. deactivating a timesheet template that is still
// some employees' default. Re-ticking it drops the question again.
export default class extends Controller {
  static targets = ["checkbox"]
  static values = { message: String }

  toggle() {
    const form = this.checkboxTarget.form
    if (!form) return

    const unticked = this.checkboxTarget.defaultChecked && !this.checkboxTarget.checked
    if (unticked) {
      form.dataset.turboConfirm = this.messageValue
    } else {
      delete form.dataset.turboConfirm
    }
  }
}
